import axios from "axios";
import { API_BASE_IP } from "./ApiClient";

export async function uploadSGF(token, sgfString, gameId) {

  console.log('Posting to Django the game', gameId.slice(0,6),'with moves:',sgfString)
  try {
    const response = await axios.post(
      `https://${API_BASE_IP}/api/sgf/`,
      { sgf_content: sgfString, game_id: gameId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Pass the token for authentication
        },
      }
    );
    console.log("Upload successful:", response.data);
    return response.data
  } catch (error) {
    console.error("Upload failed:", error.response?.data || error.message);
  }
}